export const OPTION_ALL_VALUE = "all";

export const ACTIVE_FILTER_OPTIONS = [
  { id: OPTION_ALL_VALUE, name: "Все пользователи" },
  { id: true, name: "Активные" },
  { id: false, name: "Неактивные" },
];
